import React from 'react';
import { Header, PageContainer, PageContent, Sidebar } from '../../layouts';
import { Accordion, Button, TitleLarge } from '../../components';
import { CHECKS_ICON, START_CHECKS_ICON } from '../../utils/consts';

const ProjectCheckPage = () => {
	return (
		<>
			<Header />
			<PageContainer>
				<Sidebar />
				<PageContent>
					<TitleLarge>Online-Lernportal</TitleLarge>
					<p className='text-center px-sm-3 px-md-5 mx-xl-5'>
						Entwurf und Implementierung eines interaktiven Online-Lernportals für
						Schüler: Eine benutzerfreundliche Plattform, die personalisierte
						Lernressourcen, interaktive Übungen und Fortschrittsverfolgung bietet. Ziel:
						Effektive und individualisierte Bildungsförderung für Schüler aller
						Altersgruppen.
					</p>

					<div className='container my-5'>
						<div className='row justify-content-center'>
							<div className='col-12 col-sm-9 col-xl-8'>
								<Accordion/>
								<div className='d-flex justify-content-between mt-5'>
									<Button icon={START_CHECKS_ICON} classes={'background-blue px-4'}>Prüfungen starten</Button>
									<Button icon={CHECKS_ICON} classes={'background-green px-4'}>Projekt fertigstellen</Button>
								</div>
							</div>
						</div>
					</div>
				</PageContent>
			</PageContainer>
		</>
	);
};

export default ProjectCheckPage;
